// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1kC_2","description":"PatientConsentPreview_description__1slvd"};